export default "__VITE_ASSET__6aMZZxxs__"